// Profile
export const PROFILE_SUBMIT_USER = 'PROFILE_SUBMIT_USER';
export const PROFILE_GET_DATA_USER = 'PROFILE_GET_DATA_USER';
export const PROFILE_SUBMIT_COMPANY = 'PROFILE_SUBMIT_COMPANY';
export const PROFILE_GET_DATA_COMPANY = 'PROFILE_GET_DATA_COMPANY';
export const PROFILE_SUBMIT_PASSWORD = 'PROFILE_SUBMIT_PASSWORD';
